const actions = {
  SET_STATE: "widgetChannel/SET_STATE",
  LIST: "widgetChannel/LIST",
  CREATE: "widgetChannel/CREATE",
  DETAIL: "widgetChannel/DETAIL",
  UPDATE: "widgetChannel/UPDATE",
  DELETE: "widgetChannel/DELETE",
  CHANGE_INDEXES: "widgetChannel/CHANGE_INDEXES",
};

export default actions;
